export const commonendpoint={
    userprofile:"profileUser"
}